import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TermsStyle from "../styles/estilos/TermsStyle.module.css";
import { useDataContext } from "../contexts/AuthContext";
import Swal from "sweetalert2";
import { verifyTermsAccepted } from "../services/api";
import { postTerms } from "../services/api";
import logoPng from "../images/Frame.png";

const AceptarTerminos = () => {
  const navigate = useNavigate();
  const [mayorAceptadas, setMayorAceptadas] = useState(false);
  const [botonHabilitado, setBotonHabilitado] = useState(true);
  const [accepted, setAccepted] = useState(null);
  const [loading, setLoading] = useState(true);
  const { contextData } = useDataContext();

  useEffect(() => {
    if (
      !contextData ||
      !contextData.customer ||
      !contextData.customer.lead_id
    ) {
      return;
    }
    verifyTermsAccepted(contextData.customer.lead_id)
      .then((data) => {
        if (data.accepted === true) {
          setAccepted(true);
        } else if (data.accepted === false) {
          setAccepted(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setAccepted(false);
        setLoading(false);
      });
  }, [contextData.customer.lead_id, setAccepted, setLoading]);

  const handleRedirect = () => {
    if (accepted === null) return;

    if (contextData.customer.customer_type === 3 && accepted === true) {
      navigate("/switch");
    } else if (contextData.customer.customer_type !== 3 && accepted === true) {
      navigate("/switch");
    } else if (contextData.customer.customer_type !== 3 && accepted === false) {
      navigate("/esperando");
    }
  };

  useEffect(() => {
    handleRedirect();
  }, [accepted, contextData.customer.customer_type]);

  const handleCheckboxChange = () => {
    setMayorAceptadas(true);
  };

  const handleAceptarClick = () => {
    console.log("Botón de aceptar clicado");

    if (mayorAceptadas) {
      const fechaActual = new Date(Date.now());
      const año = fechaActual.getFullYear();
      const mes = (fechaActual.getMonth() + 1).toString().padStart(2, "0");
      const dia = fechaActual.getDate().toString().padStart(2, "0");
      const horas = fechaActual.getHours().toString().padStart(2, "0");
      const minutos = fechaActual.getMinutes().toString().padStart(2, "0");
      const segundos = fechaActual.getSeconds().toString().padStart(2, "0");

      const fechaFormateada = `${año}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;

      const datos = {
        terms_accepted_at: fechaFormateada,
        terms_accepted_by: contextData.customer.id,
      };

      postTerms(datos)
        .then((data) => {
          console.log(`data recibida: ${JSON.stringify(datos)}`);
          setMayorAceptadas(true);
          setBotonHabilitado(false);

        //   Swal.fire({
        //     icon: "question",
        //     html: `<h3 class=${TermsStyle.modalTitle}>Deseas <span style="color: #d54ab7">comprar</span> alguna prenda?</h3>`,
        //     showDenyButton: true,
        //     confirmButtonText: "Si",
        //     confirmButtonColor: "#D54AB7",
        //     denyButtonText: `No gracias!`,
        //     denyButtonColor: "#0072CE",
        //   }).then((result) => {
        //     if (result.isConfirmed) {
        //       localStorage.setItem("compraAceptada", "true");
        //       // setCompraAceptada(true);
        //       navigate("/mcb");
        //     } else if (result.isDenied) {
        //       localStorage.setItem("compraAceptada", "false");
        //       // setCompraAceptada(false);
        //       navigate("/mcb/accountsSummary");
        //     }
        //   });
        // })
        // .catch((error) => {
        //   console.error(error);
        // });

          // Aceptados los T&C, vamos directo al inicio. La pregunta de comprar vs. solo
          // seguimiento (tutor) se hace en la pantalla de inicio, no acá.
          navigate("/switch");
        })
        .catch((error) => {
          console.error(error);
        });
  }
};

return (
    <>
      {loading ? ( // Mostrar indicador de carga mientras se verifica
        <div className={TermsStyle.contcargando}>
          <img
            src={logoPng}
            alt="littleBlueLogo"
            className={TermsStyle.imgcargando}
          />
          <h2 className="text-muted">CARGANDO...</h2>
          <div className={TermsStyle.loader}></div>
        </div>
      ) : (
        <div>
          {accepted !== true && (
            <>
              <div className={TermsStyle.terminos}>
                <h1 className={TermsStyle.title}>
                  TÉRMINOS Y CONDICIONES DE USO Y CONTRATACIÓN – LITTLE BLUE S.R.L.
                </h1>

                <hr />

                <h3>
                  1. Objeto y alcance
                </h3>

                <p>Los presentes Términos y Condiciones regulan el acceso, navegación, registración, uso del sitio web de LITTLE BLUE S.R.L. y de las plataformas o herramientas digitales vinculadas a su operatoria, así como la solicitud, validación, contratación, seguimiento, pago, producción, entrega, cambio, arreglo y eventual reclamo relativo a los productos y servicios comercializados por la empresa.</p>
                <p>La aceptación de estos Términos y Condiciones tendrá lugar mediante los mecanismos habilitados por LITTLE BLUE S.R.L., e implicará el reconocimiento de su contenido por parte del usuario, tutor, delegado, solicitante, cliente o representante que intervenga en la operación.</p>
                <p>Cuando la relación jurídica encuadre en una relación de consumo, resultarán aplicables las normas de orden público vigentes en la República Argentina, en especial la Ley 24.240 y el Código Civil y Comercial de la Nación. En caso de contradicción entre una disposición de estos Términos y Condiciones y una norma imperativa aplicable, prevalecerá esta última.</p>
                
                <hr />

                <h3>
                  2. Identificación del proveedor
                </h3>
                <p>Los productos y servicios ofrecidos bajo la marca LITTLE BLUE son comercializados por LITTLE BLUE S.R.L., CUIT 30-71050128-5, con domicilio en Colectora Panamericana 1807, San Isidro, Provincia de Buenos Aires, Argentina, teléfono de contacto (011) 3960-0101 y correo electrónico clientes@littleblue.com.ar.</p>
                <p>Toda comunicación vinculada con pedidos, pagos, aprobaciones, logística, cambios, arreglos, reclamos, ejercicio de derechos o cuestiones de privacidad podrá canalizarse por dichos medios o por los canales complementarios que la empresa habilite en el sitio o en la plataforma correspondiente.</p>

                <hr />

                <h3>
                  3. Usuarios habilitados y roles
                </h3>
                <p>Podrán interactuar con los servicios y herramientas de LITTLE BLUE S.R.L. las siguientes categorías de usuarios:</p>
                <ul>
                  <li>Usuario Tutor: persona humana con capacidad legal para contratar, o representante autorizado de una institución o persona jurídica, que actúa como titular principal del pedido o de la relación contractual.</li>
                  <li>Usuario Delegado: persona autorizada por el Usuario Tutor o por la institución para colaborar en la carga, revisión, validación, seguimiento o control del pedido.</li>
                  <li>Usuario Visitante: persona que navega el sitio y accede a información general sin facultad para confirmar operaciones o modificar pedidos.</li>
                </ul>
                <p>LITTLE BLUE S.R.L. podrá requerir registro previo para determinadas funcionalidades, pagos, validaciones o consultas específicas.</p>
                <hr />

                <h3>
                  4. Registración, cuenta de usuario y claves de acceso
                </h3>
                <p>El registro podrá ser gestionado por LITTLE BLUE S.R.L. en forma directa o a partir de la información suministrada por el usuario, por la institución interviniente, por sus representantes o por personas autorizadas.</p>
                <p>El usuario deberá suministrar datos veraces, completos y actualizados, y será responsable por los perjuicios que pudieran derivarse de su falsedad, omisión, inconsistencia o desactualización.</p>
                <p>Las credenciales de acceso son personales e intransferibles. El usuario será responsable de su guarda diligente y de las operaciones cursadas desde su cuenta, salvo prueba en contrario de uso indebido no imputable a su esfera de control.</p>
                <p>Cuando la cuenta sea generada por LITTLE BLUE S.R.L. a partir de datos remitidos por la institución o por terceros autorizados, la contraseña inicial podrá coincidir con el número de DNI informado para el usuario correspondiente. Dicho dato no será exhibido públicamente ni quedará visible para otros usuarios de la plataforma, y su tratamiento se realizará dentro de la operatoria interna del sistema. El usuario asume la obligación de preservar su confidencialidad y de notificar inmediatamente cualquier acceso no autorizado, utilización sospechosa o vulneración de seguridad.</p>
                <p>LITTLE BLUE S.R.L. podrá requerir el cambio de contraseña, restringir accesos, suspender o bloquear cuentas cuando existan motivos razonables de seguridad, indicios de fraude, inconsistencias de datos, uso indebido de la plataforma o incumplimientos contractuales relevantes.</p>

                <hr />

                <h3>
                  5. Naturaleza del proceso comercial y perfeccionamiento del pedido
                </h3>
                <p>La mera navegación por el sitio, la registración del usuario, la carga de datos, el pedido de presupuesto o la manifestación inicial de interés no importan por sí solos la perfección automática de una compraventa ni la aceptación definitiva de un pedido.</p>
                <p>La operatoria comercial de LITTLE BLUE S.R.L. podrá requerir intervención de asesores comerciales, representantes, coordinadores o personal autorizado, así como validaciones sucesivas referidas a diseño, talles, cantidades, aprobaciones, datos de personalización, presupuesto, calendario de pagos y factibilidad operativa.</p>
                <p>El pedido se considerará aceptado y apto para su ejecución únicamente cuando LITTLE BLUE S.R.L. confirme expresamente su viabilidad comercial y operativa por alguno de sus canales habilitados y se encuentren cumplidas las condiciones necesarias para su puesta en producción.</p>

                <hr />

                <h3>
                  06. Productos, muestras, imágenes y tolerancias
                </h3>
                <p>LITTLE BLUE S.R.L. comercializa productos textiles y otros artículos que, según el caso, pueden ser estándar, personalizados, confeccionados a pedido o producidos conforme especificaciones definidas por el cliente, por una institución, por un grupo o por usuarios autorizados.</p>
                <p>Las imágenes, renders, muestras, tablas de talles, referencias gráficas, paletas de color, bocetos y demás materiales publicados o remitidos tienen carácter informativo e ilustrativo. No obstante, LITTLE BLUE S.R.L. se compromete a respetar sustancialmente las especificaciones aprobadas para la producción, dentro de las tolerancias técnicas, de materiales y de confección razonables para este tipo de producto.</p>
                <p>Podrán existir diferencias no sustanciales derivadas del proceso de confección, personalización, escalado de talles, partidas de tela, bordado, estampado, disponibilidad razonable de insumos o variaciones propias de visualización en pantallas, siempre que no alteren de modo relevante la identidad general, funcionalidad o aptitud del producto.</p>

                <hr />

                <h3>
                  7. Formación, validación y rechazo del pedido
                </h3>
                <p>La aceptación del pedido por parte de LITTLE BLUE S.R.L. podrá quedar sujeta, según corresponda, a la validación de datos del usuario, revisión y aprobación del diseño, determinación de talles y cantidades, confirmación de nombres, apodos u otras personalizaciones, disponibilidad de insumos, factibilidad técnica, aceptación del presupuesto, aceptación del cronograma de pagos y acreditación del anticipo o pago requerido.</p>
                <p>LITTLE BLUE S.R.L. podrá rechazar o postergar fundadamente un pedido por razones de imposibilidad técnica, falta de información suficiente, inconsistencias relevantes en los datos, incumplimientos previos significativos, sospecha razonable de fraude o imposibilidad material de cumplir en condiciones adecuadas.</p>

                <hr />

                <h3>
                    8. Precios, presupuestos y promociones
                </h3>
                <p>Los precios, promociones, descuentos, presupuestos y condiciones comerciales informados por LITTLE BLUE S.R.L. tendrán la vigencia expresamente indicada en cada caso y regirán para la operación concreta en la medida en que resulten aceptados por ambas partes.</p>
                <p>Salvo estipulación expresa en contrario, las promociones no serán acumulables entre sí.</p>
                <p>Una vez aceptado el pedido y sus condiciones económicas, el precio sólo podrá variar por modificaciones solicitadas por el cliente, cambios de diseño, talles, cantidades, personalizaciones, agregados posteriores o cualquier otra alteración expresamente aceptada por el usuario o motivada por cambios sustanciales del pedido original.</p>

                <hr />

                <h3>
                  9. Medios de pago e imputación
                </h3>
                <p>Los medios de pago habilitados podrán incluir, entre otros, transferencia bancaria, depósito bancario, tarjeta de crédito, Pago Fácil u otros medios informados por LITTLE BLUE S.R.L.</p>
                <p>Cada usuario será responsable de informar correctamente el pago efectuado y de acompañar, cuando corresponda, el comprobante respectivo por los canales habilitados por la empresa. La imputación de pagos podrá quedar sujeta a verificación administrativa razonable.</p>

                <hr />

                <h3>
                  10. Anticipo individual e inicio de producción
                </h3>
                <p>Tratándose de productos personalizados y/o confeccionados a pedido, la producción únicamente podrá iniciarse respecto de cada integrante cuando, en forma conjunta, se encuentren cumplidas las siguientes condiciones: (i) diseño o boceto final confirmado; (ii) talles, cantidades y demás datos de personalización correctamente cargados y confirmados; y (iii) pago de, al menos, el cincuenta por ciento (50%) del precio total correspondiente a ese integrante, salvo que LITTLE BLUE S.R.L. hubiera informado por escrito una condición distinta para un caso particular.</p>
                <p>En los pedidos grupales con pagos individuales, la falta de cumplimiento de cualquiera de las condiciones precedentes por parte de uno o más integrantes impedirá el inicio de la producción respecto de dichos integrantes, quienes quedarán excluidos del pedido y/o de la tanda de producción correspondiente, sin que ello afecte la continuidad de la producción de aquellos integrantes que sí hubieran cumplido íntegramente con los requisitos exigidos.</p>

                <hr />

                <h3>
                  11. Mora, intereses y cargos por incumplimiento de pago
                </h3>
                <p>El cronograma de pagos será informado al cliente a través del presupuesto, la plataforma, el pedido o el canal comercial correspondiente.</p>
                <p>En caso de falta de pago de cualquiera de las cuotas o importes comprometidos, y transcurridos siete (7) días corridos desde el vencimiento de la primera cuota impaga sin que el cliente hubiere regularizado la situación, LITTLE BLUE S.R.L. podrá aplicar un interés moratorio equivalente al uno por ciento (1%) semanal sobre el saldo vencido e impago, por cada semana completa de demora.</p>
                <p>El interés moratorio se devengará desde el día ocho (8) corrido posterior al vencimiento de la primera cuota impaga y hasta la fecha de efectivo pago del saldo vencido.</p>
                <p>La mora operará en forma automática por el mero vencimiento del plazo, sin necesidad de interpelación previa. La aplicación de intereses no impedirá a LITTLE BLUE S.R.L. adoptar además las medidas operativas previstas en estos Términos y Condiciones, incluyendo suspensión de tareas, reprogramación de plazos o resolución del vínculo en los supuestos aquí contemplados.</p>

                <hr />

                <h3>
                  12. Incumplimiento del cliente y efectos operativos
                </h3>
                <p>El retraso del cliente en los pagos, en la aprobación de bocetos, en la entrega de talles, en la validación de nombres o apodos, en la remisión de información necesaria o en cualquier otra obligación operativa indispensable para la ejecución del pedido podrá producir suspensión temporal del proceso, reprogramación de la fecha estimada de entrega, pérdida de promociones o beneficios expresamente condicionados al cumplimiento en término, modificación de la prioridad productiva del pedido y, en casos graves o persistentes, resolución del vínculo conforme a la cláusula siguiente.</p>
                <p>Cuando el incumplimiento del cliente torne inviable la continuidad razonable del pedido, LITTLE BLUE S.R.L. podrá intimar al cumplimiento por un plazo razonable. Si el incumplimiento persistiere, la empresa podrá resolver la operación y efectuar una liquidación económica según el estado real de avance del pedido, los trabajos efectivamente realizados, los insumos adquiridos o comprometidos y los costos efectivamente devengados.</p>

                <hr />

                <h3>
                  13. Cancelación, desistimiento y resolución anticipada
                </h3>
                <p>Si el cliente decidiere cancelar o desistir del pedido antes de que éste se encuentre apto para ingresar en producción, LITTLE BLUE S.R.L. podrá retener las sumas necesarias para cubrir gastos administrativos, de gestión, validación, diseño preparatorio o cualquier otro costo razonablemente incurrido y debidamente vinculado al pedido.</p>
                <p>Si la cancelación, desistimiento o resolución por causa imputable al cliente se produjere una vez cumplidas las condiciones de inicio de producción previstas en la cláusula 10, o bien luego del inicio efectivo de tareas de diseño final, compra o afectación de insumos, corte, confección, bordado, estampado, personalización o cualquier otra etapa material del proceso, las sumas abonadas hasta ese momento tendrán carácter de pago a cuenta de los costos, gastos, trabajos realizados, capacidad productiva reservada y compromisos asumidos por LITTLE BLUE S.R.L., por lo que no serán reintegrables.</p>
                <p>Asimismo, si al momento de la cancelación existieren costos adicionales ya devengados, compromisos asumidos frente a terceros o trabajos ejecutados que excedieren las sumas abonadas, LITTLE BLUE S.R.L. podrá practicar la liquidación correspondiente y reclamar la diferencia resultante. Todo ello se entenderá sin perjuicio de los derechos que pudieran corresponder al cliente por aplicación de normas imperativas.</p>
                
                <hr />

                <h3>
                  14. Plazos de producción
                </h3>
                <p>Los plazos de producción informados por LITTLE BLUE S.R.L. son estimativos y se computarán desde que el pedido se encuentre íntegramente apto para producir, esto es, cuando se hallen cumplidas todas las condiciones necesarias para su ejecución.</p>
                <p>Los plazos podrán verse modificados por causas no imputables a LITTLE BLUE S.R.L., tales como demora en pagos, modificaciones solicitadas por el cliente, tardanza en aprobaciones, falta de entrega de información necesaria, fuerza mayor, caso fortuito, problemas extraordinarios de abastecimiento, conflictos logísticos o cualquier otra circunstancia ajena razonablemente no imputable a la empresa.</p>

                <hr />

                <h3>
                  15. Entrega y logística
                </h3>
                <p>La entrega podrá efectuarse mediante logística propia, correo, operador logístico externo, retiro pactado o entrega coordinada con referentes o instituciones, según la modalidad que LITTLE BLUE S.R.L. determine de acuerdo con zona, volumen, disponibilidad, características del pedido y factibilidad logística.</p>
                <p>Cuando la entrega se realice por logística propia, su alcance podrá comprender la entrega hasta el primer piso por escalera, siempre que las condiciones del inmueble y seguridad lo permitan.</p>
                <p>Cuando la entrega se realice por correo o tercero logístico, la empresa podrá cumplir su obligación poniendo el pedido a disposición en el domicilio o punto de entrega acordado, sin perjuicio de la responsabilidad que pudiera corresponder por embalaje deficiente, error imputable o incumplimiento verificable.</p>
                <p>Si al momento de la entrega no hubiera persona que reciba el pedido, o existieren errores en los datos informados por el cliente, o mediare imposibilidad no imputable a LITTLE BLUE S.R.L., el nuevo envío o reexpedición podrá quedar a cargo del cliente, previa información correspondiente.</p>

                <hr />

                <h3>
                  16. Recepción del pedido
                </h3>
                <p>Al recibir el pedido, el cliente o la persona autorizada deberá verificar razonablemente la cantidad de bultos, el estado exterior del embalaje y la existencia de daños o faltantes aparentes.</p>
                <p>Ello no limita ni reemplaza los derechos del cliente respecto de defectos de fabricación, vicios ocultos o incumplimientos de calidad detectados con posterioridad.</p>

                <hr />

                <h3>
                  17. Garantía, defectos y reclamos
                </h3>
                <p>LITTLE BLUE S.R.L. responderá por defectos de fabricación, fallas de confección, errores sustanciales respecto de las especificaciones aprobadas y demás supuestos legalmente exigibles.</p>
                <p>El cliente deberá informar el inconveniente dentro de un plazo razonable desde que lo advirtió, acompañando descripción del problema, fotografías y, cuando corresponda, la puesta a disposición del producto para su verificación.</p>
                <p>Cuando el reclamo resultare procedente y el defecto fuese imputable a LITTLE BLUE S.R.L., la empresa podrá optar, según corresponda, por reparar, adecuar, rehacer, reponer parcialmente o reemplazar el producto afectado dentro de un plazo razonable.</p>
                <p>No se considerarán defectos imputables a LITTLE BLUE S.R.L. los daños derivados de uso indebido, lavado inadecuado, intervención de terceros, conservación incorrecta, desgaste normal o cualquier otra causa ajena no atribuible a la empresa.</p>

                <hr />

                <h3>
                  18. Cambios y arreglos no imputables a la empresa
                </h3>
                <p>Cuando el cliente solicite cambios, arreglos o modificaciones que no respondan a un error o defecto imputable a LITTLE BLUE S.R.L., la empresa podrá aceptarlos o rechazarlos según su factibilidad técnica y operativa.</p>
                <p>En caso de aceptarlos, LITTLE BLUE S.R.L. podrá presupuestar el costo correspondiente y fijar un nuevo plazo de ejecución.</p>

                <hr />

                <h3>
                  19. Responsabilidad por datos cargados y aprobaciones
                </h3>
                <p>El cliente será responsable por la exactitud de los datos que cargue, valide, apruebe o remita, incluyendo talles, cantidades, nombres, apodos, personalizaciones, domicilios, autorizaciones y bocetos finales.</p>
                <p>LITTLE BLUE S.R.L. no será responsable por errores que deriven exclusiva y directamente de información incorrecta, incompleta, desactualizada o aprobada por el propio cliente, por la institución o por personas autorizadas.</p>

                <hr />

                <h3>
                  20. Disponibilidad del sistema
                </h3>
                <p>LITTLE BLUE S.R.L. procurará mantener el sitio y la plataforma en condiciones razonables de funcionamiento, pero no garantiza disponibilidad absoluta, continua e ininterrumpida.</p>
                <p>La empresa no será responsable por interrupciones temporales, tareas de mantenimiento, fallas de conectividad, hechos de terceros, ataques informáticos, eventos de fuerza mayor o cualquier otra circunstancia ajena razonablemente no imputable.</p>

                <hr />

                <h3>
                  21. Protección de datos personales
                </h3>
                <p>LITTLE BLUE S.R.L. tratará los datos personales de conformidad con la Ley 25.326 y demás normativa aplicable en la República Argentina.</p>
                <p>El responsable de la base de datos es LITTLE BLUE S.R.L., con domicilio en Colectora Panamericana 1807, San Isidro, Provincia de Buenos Aires, Argentina, teléfono (011) 3960-0101 y correo electrónico clientes@littleblue.com.ar.</p>
                <p>Los datos podrán ser recolectados directamente del usuario, por medio de formularios o plataformas, o a través de instituciones, tutores, delegados o referentes autorizados, cuando ello resulte necesario para la gestión del pedido.</p>
                <p>Las finalidades del tratamiento podrán incluir identificación del usuario, registro y administración de cuentas, gestión de pedidos, pagos y entregas, validación de talles, diseños y personalizaciones, atención al cliente, emisión de comprobantes, comunicaciones operativas vinculadas al pedido y comunicaciones comerciales propias de LITTLE BLUE S.R.L., cuando resulten legalmente procedentes.</p>
                <p>El titular de los datos podrá ejercer sus derechos de acceso, rectificación, actualización y supresión por los canales de contacto informados, acreditando identidad en forma suficiente. LITTLE BLUE S.R.L. dará curso a las solicitudes dentro de los plazos legales aplicables.</p>

                <hr />

                <h3>
                  22. Comunicaciones
                </h3>
                <p>Las notificaciones, avisos, recordatorios, solicitudes de aprobación, estado de pagos, cambios de estado del pedido, observaciones de producción, reclamos y demás comunicaciones vinculadas a la operación podrán cursarse por correo electrónico, mensajería, teléfono, plataforma o cualquier canal informado por el cliente.</p>
                <p>El cliente reconoce validez operativa a dichas comunicaciones, sin perjuicio de los medios formales que legalmente pudieran corresponder para reclamos específicos.</p>

                <hr />

                <h3>
                  23. Propiedad intelectual
                </h3>
                <p>Todos los contenidos del sitio, incluyendo textos, marcas, logos, imágenes, renders, bocetos, documentación, procesos, software y elementos gráficos, son de titularidad de LITTLE BLUE S.R.L. o de terceros que han autorizado su uso y se encuentran protegidos por la normativa aplicable.</p>
                <p>Queda prohibida su reproducción, distribución, alteración o utilización no autorizada.</p>

                <hr />

                <h3>
                  24. Modificaciones
                </h3>
                <p>LITTLE BLUE S.R.L. podrá actualizar estos Términos y Condiciones para operaciones futuras, por cambios normativos, comerciales, operativos o tecnológicos.</p>
                <p>Las modificaciones no afectarán retroactivamente pedidos ya aceptados, salvo que resulten más favorables para el cliente o que una norma imperativa exija su aplicación.</p>

                <hr />

                <h3>
                  25. Ley aplicable y jurisdicción
                </h3>
                <p>Estos Términos y Condiciones se regirán por las leyes de la República Argentina.</p>
                <p>En caso de controversia, las partes procurarán resolver el conflicto de buena fe por los canales de atención directa disponibles.</p>
                <p>Cuando exista relación de consumo, serán competentes los tribunales que determine la normativa imperativa aplicable y no se entenderá renunciado ningún derecho irrenunciable del consumidor.</p>

                <hr />
                
                <h3>
                    26. Divisibilidad
                </h3>
                <p>Si alguna disposición de estos Términos y Condiciones fuera declarada inválida, nula o inaplicable, ello no afectará la validez del resto del documento, que continuará plenamente vigente en todo lo demás.</p>
                
              </div>
              <div className={TermsStyle.form}>
                {/* Checkbox para aceptar los términos */}
                <label className={TermsStyle.label}>
                  <input
                    className={TermsStyle.check}
                    type="checkbox"
                    checked={mayorAceptadas}
                    onChange={handleCheckboxChange}
                  />
                  Soy mayor de 18 años, he leído y acepto los términos y
                  condiciones.
                </label>

                {/* Botón de aceptar */}
                <button
                  className={TermsStyle.boton}
                  onClick={handleAceptarClick}
                  disabled={!botonHabilitado}
                >
                  Aceptar
                </button>
              </div>
            </>
          )}
        </div>
      )}
      {/* <div>
      <modal1 compraAceptada={compraAceptada} />
    </div> */}
    </>
  );
};

export default AceptarTerminos;
